import { render, staticRenderFns } from "./OrderItems.vue?vue&type=template&id=1b42b361&scoped=true"
import script from "./OrderItems.vue?vue&type=script&lang=js"
export * from "./OrderItems.vue?vue&type=script&lang=js"
import style0 from "./OrderItems.vue?vue&type=style&index=0&id=1b42b361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42b361",
  null
  
)

export default component.exports